<template>
  <div id="to_info_sector" class="sector receiver-sector">
    <div class="row">
      <div class="col-12 sector__header text-accent">
        {{ $t("orders.recipientInfo") }}
      </div>
      <div class="col-12 sector__content pb-0">
        <slot></slot>
      </div>
      <el-form-item prop="to-info"></el-form-item>
    </div>
  </div>
</template>

<script setup>
import { useVModel } from "@vueuse/core";

const props = defineProps({
  modelValue: Object,
});
const emit = defineEmits(["update:modelValue"]);

const form = useVModel(props, "modelValue", emit);
</script>
<style lang="scss">
.receiver-sector {
  .sector__content {
    padding: 15px 15px;

    .el-form-item {
      margin-bottom: 6px;

      label {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>